// latest: hans 2017-11-9 2:15 PM
// 模板分配历史参照？参数type，objectId
import Collection from 'common/vo/collection'
import 'collection/templateRelation'
import operation from './opt'
import Model from 'common/vo/model'
import './index.less'
/* global $ u ko __ */

let vm
let trcollections
let HistplModel
const search = () => {
  let templateType = ''
  if (HistplModel.datatable.getValue('templateType') != null || HistplModel.datatable.getValue('templateType') != '') {
    templateType = HistplModel.datatable.getValue('templateType')
  }
  trcollections.load({
    objectId: _config.objectId,
    isCertification: _config.isCertification,
    objectType: 0,
    isGlobal: _config.isGlobal,
    templateType: templateType
  }, { url: '/cpu-supplymgr/templateAllot/pageQueryHistoryByCondition' })
}
function findName (data) {
  let title = ''
  switch (data) {
    case '1':
      title = '资质审核'
      break
    case '2':
      title = '产品试验'
      break
    case '3':
      title = '现场认证'
      break
    case '4':
      title = '招标项目评价'
      break
    case '5':
      title = '合同履约评价'
      break
    case '6':
      title = '使用效果评价'
      break
  }
  return title
}
function findLevel (data) {
  let title = ''
  switch (data) {
    case '0':
      title = '不变'
      break
    case '1':
      title = '提高'
      break
    case '2':
      title = '放宽'
      break
  }
  return title
}

async function init (refer) {
  trcollections = Collection.create('templateRelationList')
  HistplModel = Model.create('model.templateRelation')
  trcollections.load({
    objectId: _config.objectId,
    isCertification: _config.isCertification,
    objectType: 0,
    isGlobal: _config.isGlobal
  }, { url: '/cpu-supplymgr/templateAllot/pageQueryHistoryByCondition' })
  vm = {
    searchKey: ko.observable(''),
    search,
    model: HistplModel.datatable,
    comboData: ko.observableArray([]),
    gridconfig: {
      id: 'gridtpl',
      data: trcollections,
      type: 'grid',
      multiSelect: false,
      editable: false,
      pagination: true,
      fields: [{
        'field': 'templateType',
        'dataType': 'String',
        'title': '模板类型',
        'width': '10%',
        renderType (obj) {
          let templateTypeName = findName(obj.row.value.templateType)
          obj.element.innerHTML = '<span title="' + templateTypeName + '">' + templateTypeName + '</span>'
        }
      }, {
        'field': 'objectCode',
        'dataType': 'String',
        'title': '模板编码',
        'width': '10%'
      }, {
        'field': 'templateName',
        'dataType': 'String',
        'title': '模板名称',
        'width': '10%'
      }, {
        'field': 'alloterName',
        'dataType': 'String',
        'title': '分配人',
        'width': '10%'
      }, {
        'field': 'allotDate',
        'dataType': 'String',
        'title': '分配日期',
        'width': '15%'
      }, {
        'field': 'version',
        'title': '版本号',
        'dataType': 'String',
        'width': '10%'
      }, {
        'field': 'level',
        'dataType': 'String',
        'title': '标准',
        'width': '10%',
        renderType (obj) {
          let templateTypeName = findLevel(obj.row.value.level)
          obj.element.innerHTML = '<span title="' + templateTypeName + '">' + templateTypeName + '</span>'
        }
      }, {
        'field': 'changeContent',
        'title': '变更内容',
        'dataType': 'String',
        'width': '15%'
      }, {
        'field': 'operation',
        'title': __('operation'),
        dataType: 'action',
        'width': '10%',
        item: operation({
          load: async function (value) {}
        })
      }]
    }
  }
  HistplModel.datatable.on('valueChange', function (event) {
    search()
  })
  let app = u.createApp()
  app.init(vm, $('#tpl_refer')[0])
  initCom()
}
function initCom () {
  let comboData
  if (_config.isCertification == 1) {
    comboData = [{
      name: '资质审核',
      value: 1
    },
    {
      name: '产品试验',
      value: 2
    },
    {
      name: '现场认证',
      value: 3
    }
    ]
  } else {
    comboData = [{
      name: '招标项目',
      value: 4
    },
    {
      name: '合同履约',
      value: 5
    },
    {
      name: '使用效果',
      value: 6
    }
    ]
  }
  // var comboExtent = window.app.getComp('templateType')
  console.log('comboData', comboData)
  vm.comboData(comboData)
  // comboExtent.comp.setComboData(comboData)
}
let _config
let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    parentId: 0,
    canRemoveBasic: false,
    multiSelect: true,
    repeatable: false,
    objectId: 1,
    isCertification: 1,
    objectType: 0,
    isGlobal: 0
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/tplHistorySelect/index.js